/* CHS v2 storefront JS (layout/chs2): buy box, gallery, video, pairs, bundle builder, nav, dose finder, card rows.
   Prices are cents (Liquid). Cart adds go over XHR because UpCart wraps window.fetch and strips selling_plan.
   Shared helpers on window.CHS2: postAdd, openCart, refreshCount, money, planMonths, planLabel, level (card rows). */
(function () {
  'use strict';
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(c) { c = Math.round(c); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  function moneyRound(c) { return '$' + (c / 100).toFixed(2); }
  function setText(root, key, val) { qa('[data-o="' + key + '"]', root).forEach(function (e) { e.textContent = val; }); }
  function plural(n, one, many) { return (n === 1 ? one : many); }
  function fmtNum(n) { return (Math.round(n * 10) / 10).toString(); }
  // a dose unit that is a measure (mL, g) reads "0.5 mL", never "Half a mL"; count units (chew, scoop) read "Half a chew"
  function isMeasure(u) { return /^(ml|g|mg|oz|fl ?oz|l)$/i.test(String(u || '').trim()); }
  function lcFirst(t) { t = String(t || ''); return t.charAt(0).toLowerCase() + t.slice(1); }
  // a play() that is interrupted (closed straight away) rejects; keep that out of the page's error log
  function playQuiet(v) { try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {} }

  /* ---------- cart ---------- */
  function postAdd(items) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', '/cart/add.js', true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) resolve(x.responseText);
        else { var m = 'Could not add to cart.'; try { m = JSON.parse(x.responseText).description || m; } catch (e) {} reject(new Error(m)); }
      };
      x.onerror = function () { reject(new Error('Network error, please try again.')); };
      x.send(JSON.stringify({ items: items }));
    });
  }
  function refreshCount() {
    var x = new XMLHttpRequest();
    x.open('GET', '/cart.js', true);
    x.onload = function () { try { var c = JSON.parse(x.responseText); qa('[data-c2-cart-count]').forEach(function (e) { e.textContent = c.item_count; }); } catch (e) {} };
    x.send();
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
  }
  // open the UpCart drawer: reload UpCart's cart first (our adds go over XHR, so its cached cart can be stale), wait up to 8s for
  // the app to load on slow phones, and only then fall back to the cart page (operator 2026-10-29: "Upcart doesnt open")
  function openCart(tries) {
    tries = tries || 0;
    if (typeof window.upcartOpenCart === 'function') {
      try { if (typeof window.upcartRefreshCart === 'function') { var r = window.upcartRefreshCart(); if (r && typeof r.then === 'function') { r.then(function () { window.upcartOpenCart(); }, function () { window.upcartOpenCart(); }); return; } } } catch (e) {}
      window.upcartOpenCart(); return;
    }
    if (tries > 80) { window.location.href = '/cart'; return; }
    setTimeout(function () { openCart(tries + 1); }, 100);
  }
  // the nav cart icon opens the drawer itself rather than relying on UpCart's own click capture
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-c2-cart-link]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || typeof window.upcartOpenCart !== 'function') return;
    e.preventDefault(); openCart();
  });
  window.CHS2 = window.CHS2 || {};
  window.CHS2.postAdd = postAdd; window.CHS2.openCart = openCart; window.CHS2.refreshCount = refreshCount;

  /* ---------- plans ---------- */
  function planMonths(name) {
    var m = /(\d+)\s*day/i.exec(name || ''); if (m) return Math.max(1, Math.round(+m[1] / 30));
    m = /(\d+)\s*month/i.exec(name || ''); if (m) return +m[1];
    m = /(\d+)\s*week/i.exec(name || ''); if (m) return Math.max(1, Math.round(+m[1] / 4.3));
    return 1;
  }
  function planLabel(months) { return months === 1 ? 'Monthly' : 'Every ' + months + ' months'; }
  function intervalText(months) { return months === 1 ? 'every month' : 'every ' + months + ' months'; }

  /* ---------- buy box ---------- */
  function BuyBox(root) {
    var dataEl = q('[data-c2-data]', root.parentNode) || q('[data-c2-data]');
    if (!dataEl) return;
    var D = JSON.parse(dataEl.textContent);
    var V = D.variants;
    var units = {};
    (D.units || []).forEach(function (l) {
      var kv = String(l).split('|'); if (kv.length < 2) return;
      var t = kv[0].trim(), u = kv[1].trim();
      var m = /^(\d+(?:\.\d+)?)\s*d$/i.exec(u);
      if (m) units[t] = { days: +m[1] };
      else if (u && !isNaN(+u)) units[t] = { n: +u };
    });
    var ladder = V.length > 1 && V.every(function (v) { return /(\d+)\s*day/i.test(v.title); });
    function supplyDaysOfTitle(t) { var m = /(\d+)\s*day/i.exec(t); return m ? +m[1] : 0; }
    var base = null;
    if (ladder) { base = V.slice().sort(function (a, b) { return supplyDaysOfTitle(a.title) - supplyDaysOfTitle(b.title); })[0]; }
    function mult(v) { return ladder ? Math.max(1, Math.round(supplyDaysOfTitle(v.title) / supplyDaysOfTitle(base.title))) : 1; }
    function getV(id) { for (var i = 0; i < V.length; i++) if (V[i].id === id) return V[i]; return V[0]; }
    // What qty of v costs, as the cart charges it: price (one-time), first (first subscription order), then (each renewal), reg
    // (the regular price a renewal % is taken from), tier (the supply discount reached). A supply ladder posts the base pack x
    // bags, and the store's supply discounts by bag count (Gut: 15% from 2 bags, 30% from 3; tier k = 1 - price_k / (k x base))
    // have recurringCycleLimit 1: first order only (Admin read 2026-10-21). So: at quantity 1 the size's own prices; above that,
    // bags x base less the best tier the bag count reaches; renewals the base plan's renewal for every bag. Same rule as the
    // bundle builder (chs2-bundle.js calc), checked there against real carts (60 Day x2 one-time $70; 30 Day x2 $42.50).
    var tiers = ladder ? V.map(function (v) { var k = mult(v); return { k: k, pct: k > 1 ? 1 - v.price / (k * base.price) : 0, v: v }; })
      .filter(function (t) { return t.k > 1 && t.pct > 0; }) : [];
    function tierFor(n) { var r = null; tiers.forEach(function (t) { if (t.k <= n && (!r || t.pct > r.pct)) r = t; }); return r; }
    function quote(v, qty, p) {
      if (!ladder) return { price: v.price * qty, first: p ? p.price * qty : null, then: p ? p.then * qty : null, reg: v.price * qty, tier: null };
      var k = mult(v), n = qty * k, t = tierFor(n), pct = t ? t.pct : 0, bp = null;
      if (p) for (var i = 0, bps = plansOf(base); i < bps.length; i++) if (bps[i].id === p.id) bp = bps[i];
      return { price: qty === 1 ? v.price : Math.round(base.price * n * (1 - pct)),
        first: !p ? null : qty === 1 ? p.price : Math.round((bp ? bp.price : p.price / k) * n * (1 - pct)),
        then: !p ? null : bp ? bp.then * n : p.then * qty, reg: base.price * n, tier: t };
    }
    function plansOf(v) { return (v.plans || []).slice().sort(function (a, b) { return planMonths(a.name) - planMonths(b.name); }); }
    function isTrial(v) { var u = units[v.title]; if (!u || !u.n) return false; return V.some(function (o) { var uo = units[o.title]; return o.id !== v.id && uo && uo.n && uo.n >= u.n * 3; }); }

    var st = { vid: D.open.variant, purchase: D.open.purchase === 'subscribe' ? 'subscribe' : 'onetime', planId: null, planAuto: true, band: null, qty: 1 };
    var addBtns = qa('[data-c2-add]'); addBtns.forEach(function (b) { b._c2html = b.innerHTML; });
    if (!plansOf(getV(st.vid)).length) st.purchase = 'onetime';

    function dose() { if (st.band == null || !D.bands[st.band]) return null; var d = parseFloat(String(D.bands[st.band].dose).replace(',', '.')); return isNaN(d) ? null : d; }
    function unitWord(d) { return d === 1 ? D.unit : (D.unitPlural || D.unit); }
    function doseText(d) { if (d === 0.5 && !isMeasure(D.unit)) return 'Half a ' + D.unit; return fmtNum(d) + ' ' + unitWord(d); }
    // a pack sold as N days of supply ("30 Day") at more than 1 unit a day: no source says how long it lasts then (DELTA D2)
    function dayPackOverDose(v) { var d = dose(); return isDayPack(v) && d != null && d > 1; }
    // the smallest quantity whose days reach the delivery interval (same 1-day tolerance as the run-short check), or 0 above 9
    function qtyFor(v, iv) { for (var n = 1; n <= 9; n++) { var dd = daysFor(v, n); if (dd != null && dd + 1 >= iv) return n; } return 0; }
    // days one order lasts: counted packs at the chosen dose; packs sold as N days of supply ("60 Day|60d") last N days
    function daysFor(v, qty) { var u = units[v.title], d = dose(); if (!u) return null; if (u.days) return u.days * (qty || 1); if (!d || !u.n) return null; return Math.floor((u.n * (qty || 1)) / d); }
    function isDayPack(v) { var u = units[v.title]; return !!(u && u.days); }
    // where Subscribe & Save is when this size has no plan (the 10-count trials carry only the 15% group, not the one shown)
    function subWhere() {
      var alt = V.filter(function (o) { return plansOf(o).length && o.available; })[0]; if (!alt) return null;
      var au = units[alt.title]; return au && au.n ? au.n + '-count' : alt.title;
    }
    function subNaText() {
      if (D.subNa) return D.subNa;
      var w = subWhere(), g = D.group ? D.group.name : 'Subscribe & Save';
      return w ? g + ' is on the ' + w + '.' : g + ' is not available right now.';
    }
    function fitVariant() {
      var d = dose(); if (!d) return null;
      var cands = V.filter(function (v) { var u = units[v.title]; return v.available && u && u.n && !isTrial(v); });
      if (!cands.length) return null;
      cands.sort(function (a, b) { return units[a.title].n - units[b.title].n; });
      for (var i = 0; i < cands.length; i++) { if (units[cands[i].title].n / d >= 28) return cands[i]; }
      return cands[cands.length - 1];
    }
    function currentPlan(v) {
      var ps = plansOf(v); if (!ps.length) return null;
      if (!st.planAuto && st.planId) { for (var i = 0; i < ps.length; i++) if (ps[i].id === st.planId) return ps[i]; }
      if (dayPackOverDose(v)) return ps[0];
      var days = daysFor(v, st.qty);
      if (days != null && isDayPack(v)) {
        // a pack sold as N days of supply: the plan whose interval matches it (60 Day: every 2 months, 90 Day: every 3 months)
        var want = days / 30.4, near = ps[0], gap = Infinity;
        ps.forEach(function (p) { var g = Math.abs(planMonths(p.name) - want); if (g < gap - 1e-9) { gap = g; near = p; } });
        return near;
      }
      if (days != null) {
        var best = ps[0];
        ps.forEach(function (p) { if (planMonths(p.name) * 30.4 <= days + 1) best = p; });
        return best;
      }
      return ps[0];
    }

    function render() {
      var v = getV(st.vid), d = dose(), ps = plansOf(v), plan = currentPlan(v), qty = st.qty, days = daysFor(v, qty);
      var hasSub = !!q('[data-c2-plan="subscribe"]', root);
      if (!ps.length && st.purchase === 'subscribe') st.purchase = 'onetime';
      var sub = st.purchase === 'subscribe' && plan;
      var Q = quote(v, qty, plan), price = Q.price, first = Q.first, then = Q.then;
      var pay = sub ? first : price;

      // packs + fit marker
      var fit = fitVariant();
      qa('[data-c2-pack]', root).forEach(function (b) {
        var on = +b.getAttribute('data-c2-pack') === v.id;
        b.setAttribute('aria-pressed', String(on)); b.setAttribute('aria-checked', String(on));
        var f = q('[data-fit]', b); if (!f) return;
        if (fit && +b.getAttribute('data-c2-pack') === fit.id && st.band != null) { f.hidden = false; f.textContent = 'Right size for ' + lcFirst(D.bands[st.band].label); } else { f.hidden = true; }
      });
      // bands
      qa('[data-c2-band]', root).forEach(function (b) { var on = +b.getAttribute('data-c2-band') === st.band; b.setAttribute('aria-pressed', String(on)); b.setAttribute('aria-checked', String(on)); });
      // dose line
      var doseEl = q('[data-o="dose"]', root);
      if (doseEl) {
        if (d == null) { doseEl.textContent = D.dosePrompt || ''; }
        else {
          var u = units[v.title], txt = '<b>' + doseText(d) + ' a day</b>';
          if (days != null && !isDayPack(v)) txt += ' · ' + (qty > 1 ? qty + ' ' + D.packNoun + 's last' : 'one ' + D.packNoun + ' lasts') + ' about ' + days + ' days';
          doseEl.innerHTML = txt;
        }
      }
      // bridge (trial only)
      var br = q('[data-c2-bridge]', root);
      if (br) {
        var big = null;
        if (D.bridge && isTrial(v)) {
          V.forEach(function (o) { var uo = units[o.title]; if (o.available && uo && uo.n && !isTrial(o) && (!big || uo.n > units[big.title].n)) big = o; });
        }
        if (big) {
          var ut = units[v.title].n, ub = units[big.title].n, bp = plansOf(big)[0];
          var line = 'Trial: <b>' + moneyRound(v.price / ut) + ' a ' + D.unit + '</b> · ' + ub + '-count';
          if (bp && D.group) line += ' on ' + D.group.name + ': <b>' + moneyRound(bp.price / ub) + ' a ' + D.unit + '</b> on the first ' + D.packNoun + (bp.then !== bp.price ? ', then ' + moneyRound(bp.then / ub) : '') + '.';
          else line += ': <b>' + moneyRound(big.price / ub) + ' a ' + D.unit + '</b>.';
          br.innerHTML = '<span>' + line + '</span><button type="button" data-c2-pick="' + big.id + '">See the ' + ub + '-count</button>';
          br.hidden = false;
        } else { br.hidden = true; br.innerHTML = ''; }
      }
      // purchase cards
      var subCard = q('[data-c2-plan="subscribe"]', root), oneCard = q('[data-c2-plan="onetime"]', root);
      if (subCard) {
        subCard.setAttribute('aria-checked', String(!!sub));
        subCard.setAttribute('aria-disabled', String(!ps.length));
        var subPr = q('[data-o="sub"]', subCard);
        if (subPr) { if (plan) subPr.textContent = money(first); else { var sw = subWhere(); subPr.innerHTML = '<span class="na">' + (sw ? 'On the ' + sw : 'Not on this size') + '</span>'; } }
        setText(subCard, 'subwas', plan && first < price ? money(price) : '');
        var cads = q('[data-c2-cads]', subCard);
        if (cads) {
          if (ps.length > 1) {
            cads.innerHTML = '<span>Delivers</span>' + ps.map(function (p) { return '<button type="button" data-c2-cad="' + p.id + '" aria-pressed="' + (plan && p.id === plan.id) + '">' + planLabel(planMonths(p.name)) + '</button>'; }).join('');
            cads.hidden = false;
          } else if (ps.length === 1) { cads.innerHTML = '<span>Delivers ' + intervalText(planMonths(ps[0].name)) + '</span>'; cads.hidden = false; }
          else { cads.innerHTML = '<span>' + subNaText() + '</span>'; }
        }
        var terms = q('[data-o="subterms"]', subCard);
        if (terms) {
          if (plan) {
            var pctFirst = Math.round((1 - first / price) * 100), pctThen = Math.round((1 - then / Q.reg) * 100);
            // a supply ladder renewal can cost as much as buying the same supply one-time: no "% off" claim then, and say why
            var firstOnly = Q.tier && then >= price;
            terms.textContent = then !== first
              ? pctFirst + '% off your first order (' + money(first) + '), then ' + money(then) + ' ' + intervalText(planMonths(plan.name))
                + (firstOnly ? '. The ' + supplyDaysOfTitle(Q.tier.v.title) + '-day supply price applies to the first order only.' : ' (' + pctThen + '% off)')
              : 'Save ' + pctFirst + '% on every delivery, ' + money(first) + ' ' + intervalText(planMonths(plan.name));
            terms.hidden = false;
          } else { terms.hidden = true; }
        }
        var cn = q('[data-o="cadnote"]', subCard);
        if (cn) {
          var shipTxt = plan ? ' Deliveries come ' + intervalText(planMonths(plan.name)) + '; allow up to about 2 weeks for each one to arrive.' : '';
          if (plan && dayPackOverDose(v)) {
            // "30 Day" is the bag's own label; it does not say what dose those 30 days assume, so no supply, run-short or spare advice
            cn.textContent = 'The label does not say how long one ' + D.packNoun + ' lasts at ' + doseText(d) + ' a day.' + shipTxt;
            cn.hidden = false;
          } else if (plan && days != null) {
            var iv = Math.round(planMonths(plan.name) * 30.4), what = qty > 1 ? qty + ' ' + D.packNoun + 's last' : 'One ' + D.packNoun + ' lasts';
            var txt = (isDayPack(v) ? 'A ' + days + '-day supply.' : what + ' about ' + days + ' days at this dose.') + shipTxt;
            if (days >= iv * 1.5) txt += ' That sends about ' + Math.round(days / iv) + ' times what one dog uses, so skip deliveries from your account when you have spares.';
            else if (iv > days + 1) { var nq = qtyFor(v, iv); txt += ' You would run short between deliveries: ' + (nq ? 'choose a quantity of ' + nq + ' or a shorter interval.' : 'choose a shorter interval.'); }
            if (D.recommendOneTime && days > 183) txt += ' At this dose a one-time order may suit you better.';
            cn.textContent = txt;
            cn.hidden = false;
          } else { cn.hidden = true; }
        }
      }
      if (oneCard) {
        oneCard.setAttribute('aria-checked', String(!sub));
        setText(oneCard, 'one', money(price));
        setText(oneCard, 'onewas', v.compare > v.price ? money(v.compare * qty) : '');
      }
      // header price
      setText(root, 'hdr', money(pay));
      setText(root, 'hdrwas', sub ? money(price) : (v.compare > v.price ? money(v.compare * qty) : ''));
      var note = '';
      if (sub) note = 'first order with ' + (D.group ? D.group.name : 'subscription');
      // a pack sold as N days of supply gives no per-day cost above 1 unit a day: no source says what dose its N days assume (D2)
      if (days != null && days > 0 && !(isDayPack(v) && d != null && d > 1)) {
        // One-time: cost per day of use. Subscribe: what you spend per day, which is set by the delivery
        // interval when deliveries come faster than a pack is used (otherwise by the pack's days).
        var eff = sub ? Math.min(days, Math.round(planMonths(plan.name) * 30.4)) : days;
        note += (note ? ' · ' : '') + money(pay / eff) + ' a day' + (sub && then !== first ? ', then ' + money(then / eff) : '');
      }
      setText(root, 'hdrnote', note);
      // qty + cta. A sold-out size: every add button (the main one and the phone sticky bar's) reads "Sold out" and the quantity
      // stepper is off; picking an in-stock size puts each button's own label back (with its price span, filled just below).
      setText(root, 'qty', String(qty));
      var dec = q('[data-c2-qty="-1"]', root); if (dec) dec.disabled = qty <= 1 || !v.available;
      var inc = q('[data-c2-qty="1"]', root); if (inc) inc.disabled = !v.available;
      addBtns.forEach(function (b) {
        b.disabled = !v.available;
        if (!v.available) { if (b.getAttribute('data-c2-so') !== '1') { b.setAttribute('data-c2-so', '1'); b.textContent = 'Sold out'; } }
        else if (b.getAttribute('data-c2-so') === '1') { b.removeAttribute('data-c2-so'); b.innerHTML = b._c2html; }
      });
      setText(root, 'cta', money(pay));
      setText(document, 'sticky', !v.available ? money(price) : money(pay) + (sub ? ' · ' + (D.group ? D.group.name : 'Subscribe') : ' · One-time'));
      setText(root, 'ctaerr', '');
      // gallery image follows the variant if it has its own
    }

    function add() {
      var v = getV(st.vid); if (!v.available) return;
      var plan = st.purchase === 'subscribe' ? currentPlan(v) : null;
      var target = ladder ? base : v, qn = st.qty * mult(v);
      var item = { id: target.id, quantity: qn, properties: { _pdp: D.pdpTag || 'v2' } };
      if (plan) item.selling_plan = plan.id;
      var btns = qa('[data-c2-add]'); btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      postAdd([item]).then(function () { refreshCount(); openCart(); })
        .catch(function (e) { setText(root, 'ctaerr', e.message); })
        .then(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
    }

    root.addEventListener('click', function (e) {
      var t = e.target, b;
      if ((b = t.closest('[data-c2-pack]'))) { st.vid = +b.getAttribute('data-c2-pack'); return render(); }
      if ((b = t.closest('[data-c2-pick]'))) { st.vid = +b.getAttribute('data-c2-pick'); render(); var pk = q('[data-c2-pack="' + st.vid + '"]', root); if (pk) pk.focus(); return; }
      if ((b = t.closest('[data-c2-band]'))) { st.band = +b.getAttribute('data-c2-band'); return render(); }
      if ((b = t.closest('[data-c2-cad]'))) { e.stopPropagation(); st.planId = +b.getAttribute('data-c2-cad'); st.planAuto = false; st.purchase = 'subscribe'; return render(); }
      if ((b = t.closest('[data-c2-qty]'))) { if (b.disabled) return; st.qty = Math.min(9, Math.max(1, st.qty + (+b.getAttribute('data-c2-qty')))); return render(); }
      if ((b = t.closest('[data-c2-plan]'))) {
        var want = b.getAttribute('data-c2-plan');
        if (want === 'subscribe' && !plansOf(getV(st.vid)).length) { setText(root, 'ctaerr', subNaText()); return; }
        st.purchase = want; return render();
      }
    });
    root.addEventListener('keydown', function (e) {
      var b = e.target.closest('[data-c2-plan]'); if (!b) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); b.click(); }
    });
    qa('[data-c2-add]').forEach(function (b) { b.addEventListener('click', add); });

    // sticky bar (phones): visible once the main CTA has scrolled under the sticky nav
    var sticky = q('[data-c2-sticky]'), cta = q('.c2-ctarow', root), ticking = false;
    function stickyCheck() {
      ticking = false; if (!sticky || !cta) return;
      // the bar shows once the CTA row has gone under the sticky nav (not only past the top of the screen)
      var r = cta.getBoundingClientRect(), nv = q('[data-c2-nav]'), nb = nv ? Math.max(0, nv.getBoundingClientRect().bottom) : 0;
      var show = r.bottom < nb && window.innerWidth <= 860;
      if (sticky.getAttribute('data-show') === String(show)) return;
      sticky.setAttribute('data-show', String(show)); sticky.setAttribute('aria-hidden', String(!show));
      qa('button', sticky).forEach(function (x) { x.tabIndex = show ? 0 : -1; });
    }
    if (sticky && cta) {
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(stickyCheck); } }, { passive: true });
      window.addEventListener('resize', stickyCheck); stickyCheck();
    }
    // handoff from the homepage dose finder: ?band=N&buy=sub|one sets the weight band (and with it the right pack) and the purchase type
    try {
      var qs = new URLSearchParams(window.location.search), qb = qs.get('band'), qbuy = qs.get('buy');
      if (qb !== null && D.bands[+qb]) { st.band = +qb; var fv = fitVariant(); if (fv) st.vid = fv.id; }
      if (qbuy === 'sub' && plansOf(getV(st.vid)).length) st.purchase = 'subscribe'; else if (qbuy === 'one') st.purchase = 'onetime';
    } catch (e) {}
    render();
    window.CHS2.buy = { state: st, render: render, data: D };
  }

  /* ---------- gallery + video ---------- */
  var modalOpener = null;
  function openVideo(src, poster) {
    var m = q('[data-c2-modal]'); if (!m) { window.open(src, '_blank'); return; }
    if (!m.getAttribute('role')) { m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); if (!m.getAttribute('aria-label')) m.setAttribute('aria-label', 'Video'); }
    modalOpener = document.activeElement;
    var v = q('[data-c2-modal-video]', m); v.src = src; if (poster) v.poster = poster;
    m.hidden = false;
    var x = q('button[data-c2-modal-close]', m) || q('[data-c2-modal-close]', m); if (x && x.focus) x.focus();
    playQuiet(v);
  }
  document.addEventListener('click', function (e) {
    var t = e.target, b;
    if ((b = t.closest('[data-c2-menu]'))) {
      var d = q('[data-c2-drawer]'), open = d.getAttribute('data-open') !== 'true';
      setDrawer(open);
      // opened from the keyboard (Enter/Space: a click with no pointer detail): focus moves to the first link, so the brand and
      // cart links between the button and the drawer are not in the way; Escape brings it back to the button
      if (open && e.detail === 0) { var fl = q('a,button', d); if (fl) fl.focus(); }
      return;
    }
    // drawer Shop: reveal / hide the product cards
    if ((b = t.closest('[data-c2-dshop]'))) {
      var dp = document.getElementById(b.getAttribute('aria-controls')), dopen = b.getAttribute('aria-expanded') !== 'true';
      b.setAttribute('aria-expanded', String(dopen)); if (dp) dp.hidden = !dopen;
      return;
    }
    // desktop Shop chevron: open / close the mega menu (keyboard and touch; mouse users get it on hover)
    if ((b = t.closest('[data-c2-mega-btn]'))) { setMega(!megaOpen()); if (megaOpen() && e.detail === 0) { var fc = q('[data-c2-mega] a'); if (fc) fc.focus(); } return; }
    // a drawer link closes the drawer (in-page links such as #our-story land with the page unlocked)
    if (t.closest('[data-c2-drawer] a')) { setDrawer(false); return; }
    if ((b = t.closest('[data-c2-thumb]'))) {
      if (b.getAttribute('data-video')) { openVideo(b.getAttribute('data-video'), b.getAttribute('data-src')); return; }
      var gal = b.closest('[data-c2-gal]'), img = q('[data-c2-gal-main] img', gal);
      qa('[data-c2-thumb]', gal).forEach(function (x) { x.removeAttribute('aria-current'); });
      b.setAttribute('aria-current', 'true');
      if (img) { img.removeAttribute('srcset'); img.src = b.getAttribute('data-src'); }
      return;
    }
    if ((b = t.closest('[data-c2-video]'))) { openVideo(b.getAttribute('data-c2-video'), b.getAttribute('data-c2-poster')); return; }
    if ((b = t.closest('[data-c2-modal-close]'))) {
      var m = b.closest('[data-c2-modal]'), v = q('video', m); try { v.pause(); } catch (x) {} v.removeAttribute('src'); v.load(); m.hidden = true;
      if (modalOpener && modalOpener.focus && document.contains(modalOpener)) modalOpener.focus(); modalOpener = null;
      return;
    }
    if ((b = t.closest('[data-c2-vplay]'))) {
      var fr = b.closest('.c2-vframe'); if (fr.getAttribute('data-playing') === 'true') return;
      var vid = document.createElement('video');
      vid.src = b.getAttribute('data-c2-vplay'); vid.controls = true; vid.playsInline = true; vid.setAttribute('playsinline', ''); vid.autoplay = true; vid.poster = b.getAttribute('data-poster') || '';
      fr.appendChild(vid); fr.setAttribute('data-playing', 'true'); b.remove();
      playQuiet(vid);
      return;
    }
    if ((b = t.closest('[data-c2-padd]'))) {
      e.preventDefault();
      var id = +b.getAttribute('data-c2-padd'); if (!id || b.getAttribute('data-state') === 'busy') return;
      b.setAttribute('data-state', 'busy'); var label = b.textContent;
      postAdd([{ id: id, quantity: 1, properties: { _pdp: 'v2-pairs' } }])
        .then(function () { b.setAttribute('data-state', 'added'); b.textContent = 'Added'; refreshCount(); openCart(); setTimeout(function () { b.removeAttribute('data-state'); b.textContent = label; }, 2600); })
        .catch(function () { b.removeAttribute('data-state'); b.textContent = 'Try again'; });
      return;
    }
  });
  /* ---------- Shop mega menu (desktop): hover the Shop link or the panel; the chevron and keyboard focus work too ---------- */
  var megaT = null;
  function megaNav() { return q('[data-c2-nav]'); }
  function megaOpen() { var n = megaNav(); return !!n && n.getAttribute('data-mega') === 'open'; }
  function setMega(open) {
    var n = megaNav(), btn = q('[data-c2-mega-btn]'); if (!n || !q('[data-c2-mega]')) return; clearTimeout(megaT);
    if (open && window.innerWidth <= 860) return;
    if (open) n.setAttribute('data-mega', 'open'); else n.removeAttribute('data-mega');
    if (btn) btn.setAttribute('aria-expanded', String(open));
  }
  (function () {
    var wrap = q('[data-c2-mega-wrap]'), panel = q('[data-c2-mega]'); if (!wrap || !panel) return;
    var hover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function enter() { if (hover) { clearTimeout(megaT); megaT = setTimeout(function () { setMega(true); }, 60); } }
    function leave() { if (hover) { clearTimeout(megaT); megaT = setTimeout(function () { setMega(false); }, 200); } }
    [wrap, panel].forEach(function (el) { el.addEventListener('mouseenter', enter); el.addEventListener('mouseleave', leave); });
    // focus leaving both the Shop item and the panel closes it
    document.addEventListener('focusin', function (e) { if (megaOpen() && !wrap.contains(e.target) && !panel.contains(e.target)) setMega(false); });
    // a click outside closes it; a click on a card or link inside navigates
    document.addEventListener('click', function (e) { if (megaOpen() && !wrap.contains(e.target) && !panel.contains(e.target)) setMega(false); });
    window.addEventListener('resize', function () { if (megaOpen() && window.innerWidth <= 860) setMega(false); });
  })();
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (megaOpen()) { setMega(false); var mbt = q('[data-c2-mega-btn]'); if (mbt) mbt.focus(); return; }
    var m = q('[data-c2-modal]:not([hidden])'); if (m) { var c = q('[data-c2-modal-close]', m); if (c) c.click(); return; }
    var d = q('[data-c2-drawer][data-open="true"]');
    if (d) { var mb = q('[data-c2-menu]'); setDrawer(false); if (mb) mb.focus(); }
  });

  /* ---------- phone drawer: while open, the page behind is locked (no scroll, inert, Tab loops inside the header) and a tap outside
     the header closes it (mobile audit 2026-10-29) ---------- */
  var drawerInert = [], drawerY = null;
  function drawerHead() { var n = q('[data-c2-nav]'); return n ? (n.closest('.shopify-section') || n) : null; }
  function setDrawer(open) {
    var d = q('[data-c2-drawer]'), mb = q('[data-c2-menu]'), head = drawerHead(); if (!d) return;
    if ((d.getAttribute('data-open') === 'true') === open) return;
    // the drawer sits in the sticky header's flow, so it pushes the page down by its height: the page keeps its place on screen
    // (scrollY + drawer height while open, back on close), as the browser's own scroll anchoring did before the scroll lock
    var y = window.pageYOffset;
    d.setAttribute('data-open', String(open)); if (mb) mb.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('c2-dr-open', open);
    // (at the very top the browser does not anchor either: the drawer then opens in place and pushes the page down)
    if (open) { drawerY = y; if (y > 0) window.scrollTo(0, y + d.offsetHeight); }
    else if (drawerY !== null) { window.scrollTo(0, drawerY); drawerY = null; }
    drawerInert.forEach(function (el) { el.removeAttribute('inert'); }); drawerInert = [];
    if (open && head) {
      [].slice.call(document.body.children).forEach(function (el) {
        if (el === head || el.contains(head) || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName) || el.hasAttribute('inert')) return;
        el.setAttribute('inert', ''); drawerInert.push(el);
      });
    }
  }
  function drawerOpen() { var d = q('[data-c2-drawer]'); return !!d && d.getAttribute('data-open') === 'true'; }
  // a tap outside the header closes the drawer and does nothing else (capture, so the page under it does not also act)
  document.addEventListener('click', function (e) {
    if (!drawerOpen()) return; var head = drawerHead();
    if (head && !head.contains(e.target)) { e.preventDefault(); e.stopPropagation(); setDrawer(false); }
    else if (e.target.closest && e.target.closest('[data-c2-cart-link]')) setDrawer(false); // the cart drawer opens over an unlocked page
  }, true);
  // Tab and Shift+Tab loop through the header's controls while the drawer is open
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawerOpen()) return; var head = drawerHead(); if (!head) return;
    var f = [].slice.call(head.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter(function (x) { return x.offsetWidth || x.offsetHeight || x.getClientRects().length; });
    if (!f.length) return; var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || !head.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !head.contains(a))) { e.preventDefault(); first.focus(); }
  });
  // iOS Safari can still scroll a body with overflow:hidden by touch: block touch scrolling outside the drawer's own list
  document.addEventListener('touchmove', function (e) {
    if (!drawerOpen()) return; var d = q('[data-c2-drawer]');
    if (!(d && d.contains(e.target) && d.scrollHeight > d.clientHeight)) e.preventDefault();
  }, { passive: false });
  window.addEventListener('resize', function () { if (drawerOpen() && window.innerWidth > 860) setDrawer(false); });

  /* ---------- bundle builder ---------- */
  function Bundle(root) {
    var D = JSON.parse(q('[data-c2-bundle-data]').textContent);
    var picks = {}; // key pid -> {vid, purchase, qty, planId}
    function prod(pid) { for (var i = 0; i < D.products.length; i++) if (D.products[i].pid === pid) return D.products[i]; }
    function variant(p, vid) { for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === vid) return p.variants[i]; return p.variants[0]; }
    function plansOf(v) { return (v.plans || []).slice().sort(function (a, b) { return planMonths(a.name) - planMonths(b.name); }); }
    // a line's plan: the delivery interval picked on its card; else, for a pack sold as N days ("60 Day"), the plan that matches
    // those days (as the buy box does); else the shortest interval
    function plan(v, planId) {
      var ps = plansOf(v); if (!ps.length) return null;
      for (var i = 0; i < ps.length; i++) if (ps[i].id === planId) return ps[i];
      var dm = /(\d+)\s*day/i.exec(v.title || '');
      if (dm) { var want = +dm[1] / 30.4, best = ps[0], gap = Infinity; ps.forEach(function (x) { var g = Math.abs(planMonths(x.name) - want); if (g < gap - 1e-9) { gap = g; best = x; } }); return best; }
      return ps[0];
    }
    function line(p, s) { var v = variant(p, s.vid), pl = s.purchase === 'subscribe' ? plan(v, s.planId) : null; return { v: v, pl: pl, price: (pl ? pl.price : v.price) * s.qty, then: pl ? pl.then * s.qty : null }; }
    function card(pid) { return q('[data-c2-bitem="' + pid + '"]', root); }
    // the line's name is the one printed on its own card (the data block's titles can lag behind the cards)
    function nameOf(p) { var c = card(p.pid), b = c && q('.c2-bitem__b > b', c); return (b && b.textContent.trim()) || p.title; }
    function renderCard(p) {
      var c = card(p.pid); if (!c) return;
      var sel = q('select:not([data-c2-bint])', c); var vid = sel ? +sel.value : p.variants[0].id; var v = variant(p, vid);
      var purchase = (c.getAttribute('data-purchase') || 'onetime'); if (!plan(v)) purchase = 'onetime';
      qa('[data-c2-seg]', c).forEach(function (b) { var on = b.getAttribute('data-c2-seg') === purchase; b.setAttribute('aria-pressed', String(on)); b.disabled = b.getAttribute('data-c2-seg') === 'subscribe' && !plan(v); });
      // delivery interval: a choice on the card once Subscribe is on and the size has more than one plan
      var ps = plansOf(v), want = +(c.getAttribute('data-plan') || 0), pl = purchase === 'subscribe' ? plan(v, want) : null, isel = q('[data-c2-bint]', c);
      if (pl && ps.length > 1) {
        if (!isel) {
          isel = document.createElement('select'); isel.setAttribute('data-c2-bint', ''); isel.setAttribute('aria-label', 'Delivery interval for ' + nameOf(p));
          var seg = q('.c2-seg', c); if (seg) seg.parentNode.insertBefore(isel, seg.nextSibling); else c.appendChild(isel);
        }
        isel.innerHTML = ps.map(function (x) { return '<option value="' + x.id + '"' + (x.id === pl.id ? ' selected' : '') + '>' + planLabel(planMonths(x.name)) + '</option>'; }).join('');
        isel.hidden = false;
      } else if (isel) { isel.hidden = true; }
      q('[data-o="bprice"]', c).innerHTML = money(pl ? pl.price : v.price) + (pl ? '<s>' + money(v.price) + '</s>' : '');
      var qn = picks[p.pid] ? picks[p.pid].qty : 0;
      q('[data-o="bqty"]', c).textContent = String(qn);
      if (picks[p.pid]) { picks[p.pid].vid = vid; picks[p.pid].purchase = purchase; picks[p.pid].planId = pl ? pl.id : 0; }
    }
    function renderSum() {
      var ul = q('[data-c2-bsum-list]', root), tot = 0, n = 0, html = '';
      Object.keys(picks).forEach(function (k) {
        var s = picks[k]; if (!s.qty) return; var p = prod(+k), L = line(p, s);
        tot += L.price; n += s.qty;
        var vt = L.v.title.replace('Default Title', '');
        html += '<li><span>' + s.qty + ' × ' + nameOf(p) + '<small>' + (vt ? vt + ' · ' : '') + (L.pl ? D.groupName + ' · then ' + money(L.then) + ' ' + intervalText(planMonths(L.pl.name)) : 'one-time') + '</small></span><b>' + money(L.price) + '</b></li>';
      });
      ul.innerHTML = html || '<li class="empty" style="background:none;padding:0">' + D.emptyText + '</li>';
      setText(root, 'btotal', money(tot)); setText(root, 'bcount', String(n));
      var go = q('[data-c2-bgo]', root); go.disabled = !n;
    }
    root.addEventListener('change', function (e) {
      var c = e.target.closest('[data-c2-bitem]'); if (!c) return;
      if (e.target.matches('[data-c2-bint]')) c.setAttribute('data-plan', e.target.value);
      renderCard(prod(+c.getAttribute('data-c2-bitem'))); renderSum();
    });
    root.addEventListener('click', function (e) {
      var b, c = e.target.closest('[data-c2-bitem]');
      if (c && (b = e.target.closest('[data-c2-seg]'))) { c.setAttribute('data-purchase', b.getAttribute('data-c2-seg')); renderCard(prod(+c.getAttribute('data-c2-bitem'))); renderSum(); return; }
      if (c && (b = e.target.closest('[data-c2-bstep]'))) {
        var pid = +c.getAttribute('data-c2-bitem'); var s = picks[pid] || (picks[pid] = { vid: 0, purchase: 'onetime', qty: 0, planId: 0 });
        s.qty = Math.max(0, Math.min(9, s.qty + (+b.getAttribute('data-c2-bstep'))));
        renderCard(prod(pid)); renderSum(); return;
      }
      if ((b = e.target.closest('[data-c2-bgo]'))) {
        var items = [];
        Object.keys(picks).forEach(function (k) { var s = picks[k]; if (!s.qty) return; var L = line(prod(+k), s); var it = { id: L.v.id, quantity: s.qty, properties: { _pdp: 'v2-bundle' } }; if (L.pl) it.selling_plan = L.pl.id; items.push(it); });
        if (!items.length) return;
        b.disabled = true; var lab = b.textContent; b.textContent = 'Adding…';
        postAdd(items).then(function () { refreshCount(); openCart(); }).catch(function (er) { setText(root, 'berr', er.message); }).then(function () { b.disabled = false; b.textContent = lab; });
      }
    });
    D.products.forEach(renderCard); renderSum();
  }

  /* ---------- homepage dose finder (same dose, pack, interval and per-day rules as the buy box) ---------- */
  function DoseFinder(root) {
    var dataEl = q('[data-c2-df-data]', root.closest('section') || document); if (!dataEl) return;
    var D = JSON.parse(dataEl.textContent), F = D.formulas || [], fi = 0;
    var range = q('[data-c2-df-w]', root), go = q('[data-c2-df-go]', root);
    function parse(f) {
      if (f._p) return f._p;
      var units = {};
      (f.units || []).forEach(function (l) { var kv = String(l).split('|'); if (kv.length > 1 && kv[1].trim() !== '' && !isNaN(+kv[1])) units[kv[0].trim()] = +kv[1]; });
      var bands = (f.bands || []).map(function (l) { var kv = String(l).split('|'); return { label: kv[0].trim(), dose: +kv[1], min: +kv[2], max: +kv[3] }; });
      var packs = f.variants.filter(function (v) { return units[v.title]; }).map(function (v) { return { v: v, n: units[v.title] }; });
      packs = packs.filter(function (p) { return !packs.some(function (o) { return o.v.id !== p.v.id && o.n >= p.n * 3; }); }); // trial packs left out, as in the buy box
      packs.sort(function (a, b) { return a.n - b.n; });
      return (f._p = { bands: bands, packs: packs });
    }
    function render() {
      var f = F[fi], P = parse(f), w = +range.value, bi = -1;
      P.bands.forEach(function (b, i) { if (bi < 0 && w >= b.min && w <= b.max) bi = i; });
      setText(root, 'w', String(w));
      qa('[data-c2-df-f]', root).forEach(function (b) { b.setAttribute('aria-checked', String(+b.getAttribute('data-c2-df-f') === fi)); });
      if (bi < 0 || !P.packs.length) { setText(root, 'band', ''); setText(root, 'dose', 'Ask your vet'); setText(root, 'days', ''); setText(root, 'days_l', ''); setText(root, 'cad', ''); setText(root, 'note', 'The label does not give a dose for this weight.'); go.href = f.url; go.textContent = 'Open ' + f.label; return; }
      var band = P.bands[bi], d = band.dose;
      var pk = null;
      for (var i = 0; i < P.packs.length; i++) { if (P.packs[i].v.available && P.packs[i].n / d >= 28) { pk = P.packs[i]; break; } }
      if (!pk) pk = P.packs[P.packs.length - 1];
      var days = Math.floor(pk.n / d);
      var plans = (pk.v.plans || []).slice().sort(function (a, b) { return planMonths(a.name) - planMonths(b.name); });
      var plan = plans[0] || null;
      plans.forEach(function (p) { if (planMonths(p.name) * 30.4 <= days + 1) plan = p; });
      var uw = function (x) { return x === 1 ? f.unit : f.unitPlural; };
      setText(root, 'band', band.label);
      setText(root, 'dose', d === 0.5 && !isMeasure(f.unit) ? 'Half a ' + f.unit : fmtNum(d) + ' ' + uw(d));
      setText(root, 'days', days + ' days');
      var packName = /^ml$/i.test(f.unit) ? pk.n + ' ' + f.unit + ' ' + f.packNoun : pk.n + '-' + f.unit + ' ' + f.packNoun;
      setText(root, 'days_l', 'from one ' + packName);
      var note = '', buy = 'one';
      if (plan) {
        var m = planMonths(plan.name), iv = Math.round(m * 30.4), eff = Math.min(days, iv);
        if (days >= iv * 1.5) {
          // e.g. Joint Jelly at 90 lb: one 500 mL bottle lasts 250 days, the 3-month plan would send about 3 times that
          setText(root, 'cad', 'One-time'); setText(root, 'cad_l', 'suits this dose better');
          note = money(pk.v.price / days) + ' a day buying one-time (one ' + packName + ' lasts ' + days + ' days). Subscribe & Save would send about ' + Math.round(days / iv) + ' times what one dog uses.';
        } else {
          buy = 'sub';
          setText(root, 'cad', planLabel(m)); setText(root, 'cad_l', 'suggested delivery');
          note = money(plan.price / eff) + ' a day on your first Subscribe & Save order' + (plan.then !== plan.price ? ', then ' + money(plan.then / eff) + '.' : '.');
          if (iv > days + 1) {
            // the smallest quantity whose days reach the interval, with the buy box's 1-day tolerance
            var nq = 0; for (var n = 2; n <= 9; n++) { if (Math.floor(pk.n * n / d) + 1 >= iv) { nq = n; break; } }
            note += ' One ' + f.packNoun + ' runs out before the next delivery, so ' + (nq ? 'set the quantity to ' + nq + ' on the next page.' : 'choose a shorter interval on the next page.');
          }
        }
      } else {
        setText(root, 'cad', 'One-time'); setText(root, 'cad_l', 'no Subscribe & Save on this size');
        note = money(pk.v.price / days) + ' a day.';
      }
      setText(root, 'note', note);
      go.href = f.url + (f.url.indexOf('?') > -1 ? '&' : '?') + 'band=' + bi + '&buy=' + buy;
      go.textContent = (D.ctaLabel || 'Open {product}').replace('{product}', f.label).replace('{band}', band.label);
    }
    root.addEventListener('click', function (e) { var b = e.target.closest('[data-c2-df-f]'); if (!b) return; fi = +b.getAttribute('data-c2-df-f'); render(); });
    root.addEventListener('keydown', function (e) {
      var b = e.target.closest('[data-c2-df-f]'); if (!b || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      e.preventDefault(); fi = (fi + (e.key === 'ArrowRight' ? 1 : F.length - 1)) % F.length; render(); var nb = q('[data-c2-df-f="' + fi + '"]', root); if (nb) nb.focus();
    });
    range.addEventListener('input', render);
    render();
  }

  /* ---------- product card quick add (single-variant products, one-time) + need-card menus ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-c2-qadd]');
    if (b) {
      e.preventDefault(); if (b.getAttribute('aria-busy') === 'true') return;
      var label = b.textContent; b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding';
      postAdd([{ id: +b.getAttribute('data-c2-qadd'), quantity: 1, properties: { _pdp: 'v2' } }])
        .then(function () { b.textContent = 'Added'; refreshCount(); openCart(); setTimeout(function () { b.textContent = label; }, 1800); })
        .catch(function (err) { b.textContent = label; b.title = err.message; })
        .then(function () { b.removeAttribute('aria-busy'); });
      return;
    }
    // close any open need-card menu when clicking elsewhere
    qa('[data-c2-ncmenu][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target; if (!d.matches || !d.matches('[data-c2-ncmenu]') || !d.open) return;
    qa('[data-c2-ncmenu][open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
    // the menu opens upward: on a short screen (landscape phones) its first item could sit under the sticky nav, so the page
    // scrolls just enough to bring the whole list below the nav (mobile audit 2026-10-29)
    var ul = q('ul', d), nv = q('[data-c2-nav]');
    if (ul) {
      var top = ul.getBoundingClientRect().top, nb = nv ? Math.max(0, nv.getBoundingClientRect().bottom) : 0;
      if (top < nb + 8) window.scrollBy(0, top - nb - 8);
    }
  }, true);
  /* ---------- Shop mega menu (desktop): hover the Shop link or the panel; the chevron and keyboard focus work too ---------- */
  var megaT = null;
  function megaNav() { return q('[data-c2-nav]'); }
  function megaOpen() { var n = megaNav(); return !!n && n.getAttribute('data-mega') === 'open'; }
  function setMega(open) {
    var n = megaNav(), btn = q('[data-c2-mega-btn]'); if (!n || !q('[data-c2-mega]')) return; clearTimeout(megaT);
    if (open && window.innerWidth <= 860) return;
    if (open) n.setAttribute('data-mega', 'open'); else n.removeAttribute('data-mega');
    if (btn) btn.setAttribute('aria-expanded', String(open));
  }
  (function () {
    var wrap = q('[data-c2-mega-wrap]'), panel = q('[data-c2-mega]'); if (!wrap || !panel) return;
    var hover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    function enter() { if (hover) { clearTimeout(megaT); megaT = setTimeout(function () { setMega(true); }, 60); } }
    function leave() { if (hover) { clearTimeout(megaT); megaT = setTimeout(function () { setMega(false); }, 200); } }
    [wrap, panel].forEach(function (el) { el.addEventListener('mouseenter', enter); el.addEventListener('mouseleave', leave); });
    // focus leaving both the Shop item and the panel closes it
    document.addEventListener('focusin', function (e) { if (megaOpen() && !wrap.contains(e.target) && !panel.contains(e.target)) setMega(false); });
    // a click outside closes it; a click on a card or link inside navigates
    document.addEventListener('click', function (e) { if (megaOpen() && !wrap.contains(e.target) && !panel.contains(e.target)) setMega(false); });
    window.addEventListener('resize', function () { if (megaOpen() && window.innerWidth <= 860) setMega(false); });
  })();
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (megaOpen()) { setMega(false); var mbt = q('[data-c2-mega-btn]'); if (mbt) mbt.focus(); return; }
    qa('[data-c2-ncmenu][open]').forEach(function (d) {
      var had = d.contains(document.activeElement); d.removeAttribute('open');
      if (had) { var sm = q('summary', d); if (sm) sm.focus(); }
    });
  });
  window.CHS2.money = money; window.CHS2.planMonths = planMonths; window.CHS2.planLabel = planLabel;

  /* ---------- card rows: the Subscribe & Save line under a card's price runs 1 to 4 lines depending on the pack it names, so
     each row of a grid gets the height of its tallest line (prop, default --c2-sub, on every item of the row; prop + '-d' = block
     turns on the spacer of a card without the line, see chs2.css .c2-pgrid). Prices and buttons then sit level across the row.
     CHS2.level(grid, { item: '[data-cx-it]', prop: '--cx-sub', sub: '.c2-pc__sub' }); items default to the grid's children.
     Every .c2-pgrid is levelled on load, when fonts arrive and when the width changes; call it again after re-sorting a grid. ---------- */
  function level(grid, o) {
    if (!grid) return;
    o = o || {};
    var prop = o.prop || '--c2-sub', subSel = o.sub || '.c2-pc__sub';
    var items = (o.item ? qa(o.item, grid) : Array.prototype.slice.call(grid.children)).filter(function (el) { return !el.hidden && el.getClientRects().length; });
    items.forEach(function (el) { el.style.removeProperty(prop); el.style.removeProperty(prop + '-d'); });
    var rows = {};
    items.forEach(function (el) { var k = Math.round(el.getBoundingClientRect().top); (rows[k] = rows[k] || []).push(el); });
    Object.keys(rows).forEach(function (k) {
      var row = rows[k], m = 0;
      row.forEach(function (el) { var s = el.querySelector(subSel); if (s) m = Math.max(m, s.getBoundingClientRect().height); });
      if (row.length > 1 && m > 0) row.forEach(function (el) { el.style.setProperty(prop, Math.ceil(m) + 'px'); el.style.setProperty(prop + '-d', 'block'); });
    });
  }
  function levelAll() { qa('.c2-pgrid').forEach(function (g) { level(g); }); }
  window.CHS2.level = level;

  /* ---------- sticky header: the nav section sticks with the announcement scrolled away (top: minus --c2-ann-h); --c2-head-h is
     the height of what stays on screen (the nav row), for scroll-margin-top on in-page targets ---------- */
  function headVars() {
    var b = document.body; if (!b || !b.classList.contains('chs2')) return;
    var ann = q('.c2-ann'), nav = q('[data-c2-nav]'), dr = q('[data-c2-drawer]');
    b.style.setProperty('--c2-ann-h', (ann ? Math.round(ann.getBoundingClientRect().height * 100) / 100 : 0) + 'px');
    if (nav && !(dr && dr.getAttribute('data-open') === 'true')) {
      var hh = Math.ceil(nav.getBoundingClientRect().height) + 'px';
      b.style.setProperty('--c2-head-h', hh); document.documentElement.style.setProperty('--c2-head-h', hh);
    }
  }
  // the nav's "Our story" opens the homepage lineage band (#our-story) while the live about page is held back (chs2-flags)
  function storyAnchor() {
    var eb = q('.c2-eb-sec'); if (!eb || document.getElementById('our-story')) return;
    eb.id = 'our-story';
    if (window.location.hash === '#our-story') { try { document.fonts.ready.then(function () { eb.scrollIntoView(); }); } catch (e) { eb.scrollIntoView(); } }
  }

  function boot() {
    headVars(); storyAnchor();
    qa('[data-c2-dosef]').forEach(DoseFinder);
    qa('[data-c2-buy]').forEach(BuyBox);
    qa('[data-c2-bundle]').forEach(Bundle);
    levelAll();
    try { document.fonts.ready.then(function () { headVars(); levelAll(); }); } catch (e) {}
    try {
      if (window.ResizeObserver) { var ro = new ResizeObserver(function () { headVars(); }); qa('.c2-ann, [data-c2-nav]').forEach(function (el) { ro.observe(el); }); }
    } catch (e) {}
    var lastW = window.innerWidth, queued = false;
    window.addEventListener('resize', function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; headVars(); if (window.innerWidth !== lastW) { lastW = window.innerWidth; levelAll(); } });
    });
    window.addEventListener('load', levelAll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    qa('[data-c2-dosef]', t).forEach(DoseFinder); qa('[data-c2-buy]', t).forEach(BuyBox); qa('[data-c2-bundle]', t).forEach(Bundle);
    qa('.c2-pgrid', t).forEach(function (g) { level(g); }); headVars();
  });
})();
